module.exports = __webpack_public_path__ + "static/img/06.e6e1345.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/02/06.jpg
// module id = wsuu
// module chunks = 0